import React from 'react';
import {
  Grid,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
  Link,
  Button,
  TableFooter,
  TablePagination,
  Typography,
  Badge,
} from '@material-ui/core';
import {
  AssessmentOutlined as AssessmentOutlinedIcon,
} from '@material-ui/icons';

import { Helmet } from 'react-helmet';

import Commify from 'comma-number';
import { isMobile } from 'react-device-detect';
import Moment from 'moment';

import APIServer from '../../config/server.conf.json';

export default class StockConsensus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: {
        datelist: true,
        stocklist: true,
      }
    }
  }

  loadConsensusDateList = () => {
    return fetch(`${APIServer.baseUrl}/api/v1/stock/consensus/datelist`);
  }
  
  loadConsensusData = () => {
    if(this.state.selected_market === 'ALL') {
      return fetch(`${APIServer.baseUrl}/api/v1/stock/consensus/new/${this.state.selected_date}?page=${this.state.pagination.page}&limit=${this.state.pagination.limit}`);
    }

    return fetch(`${APIServer.baseUrl}/api/v1/stock/consensus/new/${this.state.selected_date}?market=${this.state.selected_market}&page=${this.state.pagination.page}&limit=${this.state.pagination.limit}`);
  }

  componentDidMount() {
    this.loadConsensusDateList()
      .then((resp) => resp.json())
      .then((resp) => {
        if(resp.status === 200) {
          resp.data.pop();

          this.setState({
            isLoading: {
              ...this.state.isLoading,
              datelist: false,
            },
            datelist: resp.data,
            selected_date: resp.data[0],
            selected_market: 'ALL',
            pagination: {
              page: 1,
              limit: 10
            }
          }, () => {
            this.loadConsensusData()
              .then((resp2) => resp2.json())
              .then((resp2) => {
                if(resp2.status === 200) {
                  this.setState({
                    ...this.state,
                    isLoading: {
                      ...this.state.isLoading,
                      stocklist: false,
                    },
                    stocklist: resp2.data,
                  });
                }
              });
          });
        }
      });
  }

  handleDateOnChange = (e) => {
    this.setState({
      ...this.state,
      selected_date: e.target.value
    });
  }

  handleMarketOnChange = (e) => {
    this.setState({
      ...this.state,
      selected_market: e.target.value
    });
  }

  handleLoadOnClick = (e) => {
    this.setState({
      ...this.state,
      isLoading: {
        ...this.state.isLoading,
        stocklist: true,
      },
      pagination: {
        ...this.state.pagination,
        page: 1
      }
    }, () => {
      this.loadConsensusData()
        .then((resp) => resp.json())
        .then((resp) => {
          if(resp.status === 200) {
            this.setState({
              ...this.state,
              isLoading: {
                ...this.state.isLoading,
                stocklist: false,
              },
              stocklist: resp.data
            });
          }
        });
    });
  }

  handleChangePage = (event, newPage) => {
    this.setState({
      ...this.state,
      pagination: {
        ...this.state.pagination,
        page: newPage + 1,
      }
    }, () => {
      this.loadConsensusData()
        .then((resp) => resp.json())
        .then((resp) => {
          if(resp.status === 200) {
            this.setState({
              ...this.state,
              isLoading: {
                ...this.state.isLoading,
                stocklist: false,
              },
              stocklist: resp.data
            });
          }
        });
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({
      ...this.state,
      pagination: {
        page: 1,
        limit: parseInt(event.target.value, 10),
      }
    }, () => {
      this.loadConsensusData()
        .then((resp) => resp.json())
        .then((resp) => {
          if(resp.status === 200) {
            this.setState({
              ...this.state,
              isLoading: {
                ...this.state.isLoading,
                stocklist: false,
              },
              stocklist: resp.data
            });
          }
        });
    });
  };

  render() {
    return (
      <Grid container style={{ padding: 10, minHeight: 450 }} spacing={3}>
        <Helmet
          title="주식정보 - 컨센서스(전문가 의견)"
          meta={[
            { name: "description", content: "주식정보 - 컨센서스(전문가 의견)" },
            { name: "keywords", content: "toolbox, tbx, 툴박스, stock, 주식, 주식정보, ,컨센서스(전문가 의견)" },
            { property: "og:title", content: "주식정보 - 컨센서스(전문가 의견) - TBX" },
            { property: "og:description", content: "주식정보 - 컨센서스(전문가 의견) - TBX" },
            { property: "og:title", content: "주식정보 - 컨센서스(전문가 의견) - TBX" },
          ]}
        />
        {this.state.isLoading.datelist &&
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <CircularProgress color="secondary" size={50} />
        </Grid>}
        {!this.state.isLoading.datelist &&
        <Grid item xs={12}>
          <FormControl style={{ margin: 10, minWidth: 100 }}>
            <InputLabel shrink>
              Market
            </InputLabel>
            <Select
              value={this.state.selected_market}
              onChange={this.handleMarketOnChange}
            >
              <MenuItem key="ALL" value="ALL">
                All
              </MenuItem>
              <MenuItem key="KOSPI" value="KOSPI">
                KOSPI
              </MenuItem>
              <MenuItem key="KOSDAQ" value="KOSDAQ">
                KOSDAQ
              </MenuItem>
            </Select>
          </FormControl>
          <FormControl style={{ margin: 10, minWidth: 100 }}>
            <InputLabel shrink>
              Date
            </InputLabel>
            <Select
              value={this.state.selected_date}
              onChange={this.handleDateOnChange}
            >
              {
                this.state.datelist.map((e) => {
                  return (
                    <MenuItem key={e} value={e}>
                      {e}
                    </MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>
          <FormControl style={{ margin: 10 }}>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              style={{ margin: 10 }}
              onClick={this.handleLoadOnClick}
            >
              조회
            </Button>
          </FormControl>
        </Grid>}
        
        {this.state.isLoading.stocklist &&
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <CircularProgress color="secondary" size={50} />
        </Grid>}
        {!this.state.isLoading.stocklist &&
        <Grid item xs={12}>
          <Typography variant="subtitle2" align="right">
            조회일: {this.state.stocklist.date}
          </Typography>
        </Grid>}
        {!this.state.isLoading.stocklist &&
        <Grid item xs={12}>
          <Paper variant="outlined">
            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell key="head-name" align="center">
                      종목명
                    </TableCell>
                    <TableCell key="head-market" align="center">
                      시장
                    </TableCell>
                    <TableCell key="head-marketRank" align="center">
                      시장 내 순위
                    </TableCell>
                    <TableCell key="head-regretBot" align="center">
                      후회봇
                    </TableCell>
                    <TableCell key="head-firstTradePrice" align="center">
                      첫 진입 가격
                    </TableCell>
                    <TableCell key="head-recentTradePrice" align="center">
                      최근가격
                    </TableCell>
                    <TableCell key="head-targetPrice" align="center">
                      목표 가격
                    </TableCell>
                    <TableCell key="head-targetPriceRate" align="center">
                      목표가 대비
                    </TableCell>
                    <TableCell key="head-consensus" align="center">
                      Consensus
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.stocklist.rows.length === 0 &&
                    <TableRow>
                      <TableCell
                        colSpan={10}
                        align="center"
                      >
                        No Data.
                      </TableCell>
                    </TableRow>
                  }
                  {this.state.stocklist.rows.map((e, i) => {
                    return (
                      <TableRow
                        key={i}
                        hover
                      >
                        <TableCell>
                          <Link href={`https://finance.naver.com/item/main.nhn?code=${e.symbol_code.substr(1)}`} target="new">
                            {e.name}
                          </Link>
                        </TableCell>
                        <TableCell align="center">
                          {e.market}
                        </TableCell>
                        <TableCell align="right">
                          {Commify(e.market_rank)}위
                        </TableCell>
                        {e.first_date_trade_price !== null &&
                          <TableCell align="center">
                            <div>
                              <span style={{
                                color: (e.trade_price-e.first_date_trade_price) < 0 ? 'blue':((e.trade_price-e.first_date_trade_price) === 0 ? 'black':'red')
                              }}>
                                {((e.trade_price-e.first_date_trade_price) > 0 ? '+':'')}{Commify(e.trade_price-e.first_date_trade_price)}
                              </span>원 
                              (<span style={{
                                color: (e.trade_price-e.first_date_trade_price) < 0 ? 'blue':((e.trade_price-e.first_date_trade_price) === 0 ? 'black':'red')
                              }}>
                                {((e.trade_price-e.first_date_trade_price) > 0 ? '+':'')}{(((e.trade_price-e.first_date_trade_price)/e.first_date_trade_price) * 100).toFixed(2)}%
                              </span>)
                            </div>
                            [{e.first_date} ~ {e.latest_price_date}]
                          </TableCell>
                        }
                        {e.first_date_trade_price === null &&
                          <TableCell align="center">
                            -
                          </TableCell>
                        }
                        {e.first_date_trade_price !== null &&
                          <TableCell align="center">
                            <div>
                              {Commify(e.first_date_trade_price)}원
                            </div>
                            [{e.first_date}]
                          </TableCell>
                        }
                        {e.first_date_trade_price === null &&
                          <TableCell align="center">
                            <div>
                              -
                            </div>
                          </TableCell>
                        }
                        <TableCell align="center">
                          <div>
                            {Commify(e.trade_price)}원
                            (<span style={{
                              color: e.change === 'FALL' ? 'blue':(e.change_rate === 0 ? 'black':'red')
                            }}>
                              {e.change === 'FALL' ? '-':(e.change_rate === 0 ? '':'+')}{(e.change_rate * 100).toFixed(2)}%
                            </span>)
                          </div>
                          [{e.latest_price_date}]
                        </TableCell>
                        <TableCell align="right">
                          {Commify(e.target_price)}원
                        </TableCell>
                        <TableCell align="center">
                          <span style={{
                            fontWeight: 700,
                            color: (e.trade_price - e.target_price) < 0 ? 'green':((e.trade_price - e.target_price) === 0 ? 'black':'grey')
                          }}>
                            {(e.trade_price - e.target_price) > 0 ? '+':''}{(((e.trade_price - e.target_price) / e.target_price) * 100).toFixed(2)}%
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          {e.lyr >= 0 && e.lyr <= 1.5 &&
                          <Paper variant="outlined" style={{ textAlign: 'center', padding: 7, color: 'white', backgroundColor: '#5793eb' }}>
                            강력매도 ({e.lyr})
                          </Paper>}
                          {e.lyr > 1.5 && e.lyr <= 2.5 &&
                          <Paper variant="outlined" style={{ textAlign: 'center', padding: 7, color: 'white', backgroundColor: '#5793eb' }}>
                            매도 ({e.lyr})
                          </Paper>}
                          {e.lyr > 2.5 && e.lyr <= 3.5 &&
                          <Paper variant="outlined" style={{ textAlign: 'center', padding: 7, color: 'white', backgroundColor: '#68b728' }}>
                            중립 ({e.lyr})
                          </Paper>}
                          {e.lyr > 3.5 && e.lyr <= 4.5 &&
                          <Paper variant="outlined" style={{ textAlign: 'center', padding: 7, color: 'white', backgroundColor: '#fe8917' }}>
                            매수 ({e.lyr})
                          </Paper>}
                          {e.lyr > 4.5 && e.lyr <= 5 &&
                          <Paper variant="outlined" style={{ textAlign: 'center', padding: 7, color: 'white', backgroundColor: '#d03b24' }}>
                            강력매수 ({e.lyr})
                          </Paper>}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[ 10, 25, 50, 100 ]}
                      rowsPerPage={this.state.pagination.limit}
                      count={this.state.stocklist.total}
                      page={this.state.pagination.page-1}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>}
      </Grid>
    );
  }
}